import React from "react";

function Weight_Gain() {
  return (
    <div className="bg-white">
      <div class="container-fluid gain-header mb-5">
        <div
          class="d-flex flex-column align-items-center justify-content-center pt-0 pt-lg-5"
          style={{minHeight: "670px"}}
        >
          <h4 class="display-4 mb-3 mt-0 mt-lg-5 text-white text-uppercase font-weight-bold">
            Bulk- Gain Diet
          </h4>
          <div class="d-inline-flex">
            <p class="m-0 text-white">
              <a class="text-white" href="">
                Home
              </a>
            </p>
            <p class="m-0 text-white px-2">/</p>
            <p class="m-0 text-white">Diet</p>
          </div>
        </div>
      </div>
      <div class="container py-5">
        <div class="row">
          <div class="col-12">
            <img class="img-fluid mb-4" src="img/gain1.png" alt="Image" />
            <div class="d-flex align-items-center mb-4">
              <div
                class="d-flex flex-column align-items-center justify-content-center rounded-circle bg-primary text-white"
                style={{width: "100px", height: "100px"}}
              >
                <span>01</span>
                <strong class="text-uppercase m-0 text-white">Jan</strong>
                <span>2023</span>
              </div>
              <div class="pl-3">
                <h1 class="font-weight-bold mb-3">Weight Gain Diet </h1>
                <div class="d-flex">
                  <span class="mr-2 text-muted">
                    <i class="fa fa-user"></i> Gymlover
                  </span>
                  <span class="mr-2 text-muted">
                    <i class="fa fa-folder"></i> Fitness
                  </span>
                  <span class="mr-2 text-muted">
                    <i class="fa fa-comments"></i> 215 Comments
                  </span>
                </div>
              </div>
            </div>
            <p>
              Here are 18 of the best foods to help you gain weight or add
              muscle, the healthy way. Homemade protein smoothies. Drinking
              homemade protein smoothies can be a highly nutritious and quick
              way to gain weight. ... Milk. ... Rice. ... Nuts and nut butters.
              ... Red meats. ... Potatoes and starches. ... Salmon and oily
              fish. ... Protein supplements.
            </p>
            <h2 class="mb-4 font-weight-bold">High Fat Foods</h2>
            <img
              class="w-50 float-left mr-4 mb-3"
              src="img/gain.jpg"
              alt="Image"
            />
            <h3 class="mb-4 font-weight-bold">carbohydrates</h3>
            <p>
              Which food is best for weight gain? Foods to gain weight quickly
              and safely Carbohydrates Rice. Rice is high in carbohydrates. ...
              Whole grain bread. Whole grain bread contains complex
              carbohydrates and is higher in protein than white bread. ... Whole
              grain cereals. Whole grain cereals include foods such as oats,
              wheat, barley, and rice. ... Dried fruits. ... Dark chocolate. ...
              Other starches
            </p>
            <h3 class="mb-4 font-weight-bold">Rice</h3>
            <img
              class="w-50 float-right ml-4 mb-3"
              src="img/blog-2.jpg"
              alt="Image"
            />
            <p>
              Rice is high in carbohydrates. For example, brown rice provides
              76.2 grams (g)Trusted Source in a 100-g serving. This type of rice
              is higher in protein than some other types of rice. A 100-g
              portion also contains 357 calories. White rice has a lower protein
              content, but a person can serve it with other foods, such as meat
              or beans, to get more protein and calories.
            </p>
            <h3 class="mb-4 font-weight-bold">Whole grain bread</h3>
            <p>
              Whole grain bread contains complex carbohydrates and is higher in
              protein than white bread. People can increase the caloric value of
              bread by topping it with a protein-rich food, such as nut butter
              or avocado. They can also prepare sandwiches containing
              nutrient-dense ingredients.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Weight_Gain;
